import {
  IsEmail,
  IsNumber,
  IsNumberString,
  IsOptional,
  IsString,
  Matches,
  MaxLength
} from 'class-validator';
import { GiftCardMediumEnum } from './giftCardMedium.enum';

export class GiftCardTransferRequestDto {
  cardNumber: number;

  // NOTE: This is a backwards compatibility property.
  @IsEmail()
  customerEmail: string;

  // NOTE: This is a backwards compatibility property.
  @IsString()
  @MaxLength(255)
  customerName: string;

  @IsNumberString()
  @Matches(/^\d{3}$/)
  cvvCode: number;

  // NOTE: This is a backwards compatibility property.
  @IsOptional()
  @IsNumber()
  giftCardMedium?: GiftCardMediumEnum | null;

  @IsNumber()
  @IsOptional()
  merchantId?: number;

  captchaValue?: string | null;

  constructor() {}
  /**
   * Sets values for the object.
   */
  from(from: {
    cardNumber: number;
    customerEmail: string;
    customerName: string;
    cvvCode: number;
    giftCardMedium?: number;
    merchantId?: number;
    captchaValue?: string;
  }) {
    this.cardNumber = from.cardNumber;
    this.customerEmail = from.customerEmail;
    this.customerName = from.customerName;
    this.cvvCode = from.cvvCode;
    this.giftCardMedium = from?.giftCardMedium;
    this.merchantId = from?.merchantId;
    this.captchaValue = from?.captchaValue;
  }
}
